import { render } from "./CredencialPage.vue?vue&type=template&id=5f1c4f9e"
import script from "./CredencialPage.vue?vue&type=script&lang=js"
export * from "./CredencialPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__